import { FC } from 'react';
import { SurveyLetterRegistrationAddress } from 'components/RadabankCard/SurveyLetterRegistrationAddress';
import { SurveyLetterRegistrationLocation } from 'components/RadabankCard/SurveyLetterRegistrationLocation';

export const SurveyLetterRegistrationAddressStep: FC = () => {
	return (
		<>
			<SurveyLetterRegistrationLocation />
			<SurveyLetterRegistrationAddress />
		</>
	);
};
